Vendd.Scripts.load(function () {
    'use strict';

    var $form = $('.x-external-cart-coupon'),
        form, cf, formData,
        $submitButton;
    var model = null;

    if ($form.length < 1)
        return;

    var firstRun = true;

    var validationOptions = {
        couponCode: {
            required: 'couponcode-required'
        }
    };

    form = $form.get(0);

    formData = {};

    form.loading = function loading (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        };
    };

    form.show = function show () {
        $form.show();
    };

    form.hide = function show () {
        $form.hide();
    };

    form.bind = function bind(html) {
        $form.html(html);

        $submitButton = $('.js-submit', $form);

        form.loading(false);

        if (firstRun) {
            $form.removeClass('x-initializing');
            $form.validationEngine(validationOptions);
            cf = $form.data('validationEngine');
            firstRun = false;
        } else {
            cf.destroy();
            $form.validationEngine(validationOptions);
            cf = $form.data('validationEngine');
        }

    };

    form.reset = function reset () {
        $('input[name="couponCode"]', $form).val("");

        $('.js-error', $form).hide();
        $('.js-success', $form).hide();

        cf.reset();
    };

    form.submit = function submit () {
        form.loading(true);

        Vendd.MessageBus.publishAsync(form, new Vendd.Cart.Messages.ApplyExternalCoupon(formData.couponCode));
    };

    $form.on('keyup', 'input[name]', function (e) {

        if (e.keyCode == 13) {
            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();

        cf.validate(fieldName);
    });

    $form.on('click', '.js-submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (cf.validate()) form.submit();

    });

    $form.on('click', '.js-clear-all', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.loading(true);

        form.reset();

        Vendd.MessageBus.publishAsync(form, new Vendd.Cart.Messages.ClearExternalCoupons());
    });

    $form.on('click', '.js-clear', function (e) {
        e.preventDefault();
        e.stopPropagation();

        Vendd.MessageBus.publishAsync(form, new Vendd.Cart.Messages.ClearExternalCoupon($(this).data('code')));
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, form, function (envelope) {
        var html, lastCoupon;

        model = envelope.message.data.Cart;

        html = Vendd.Handlebars.parse("externalCartCouponWidget", model);
        
        form.bind(html);

        if (model.IsEmpty) {
            form.hide();
        } else {
            form.show();
        };

        form.reset();
        if (formData.couponCode) {
            lastCoupon = _.find(model.ExternalCoupons.CouponItems, function (x) { return x.Code == formData.couponCode });
            if (lastCoupon && !lastCoupon.Message)
                $('.form-msg-error.invalid', $form).show();
            formData.couponCode = "";
        }

        form.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, form, function (envelope) {
        var message = envelope.message.data.data.Message;

        if (envelope.message.data.success === true) {
            $('.js-error', $form).hide();

            $('.js-success', $form).text(message).show();
        } else {
            $('.js-success', $form).hide();

            $('.js-error', $form).text(message).show();
        }

        form.loading(false);
    });
});